/**
 * useLibraryTactics - the GM's library Tactics items, for the Team tab's kill-team block (plan modes-rework): the
 * library's Tactics through `useLibraryContent`, each as the block offers it.
 *
 * @param access - the GM's library; null for none: the block then shows the Tactics its sheet already carries
 * @param wanted - read only while something shows them
 * @returns the items, newest version each, sorted by name; null without a library
 */
import type { LibraryAccess } from '../assetSession';
import type { AssetRow } from '../engine/assets/types';
import type { Tactics } from '../engine/killTeam/tactics';
import useLibraryContent from './useLibraryContent';

/** A library Tactics item as the kill-team block offers it: which asset and version, and what it holds. */
export interface LibraryTactics {
  asset: Pick<AssetRow, 'id' | 'version' | 'name'>;
  tactics: Tactics;
}

const TACTICS = ['tactics'] as const;

export default function useLibraryTactics(access: LibraryAccess | null, wanted: boolean): LibraryTactics[] | null {
  const items = useLibraryContent(access, TACTICS, wanted);
  return items?.map((i) => ({ asset: i.asset, tactics: i.content })) ?? null;
}
